const prvaDiagnozaZavarovanec = {
    ime: {
        name: 'ime',
        type: 'xs:string',
        formType: 'text-input',
        required: true,
        value: '',
        text: {
            sl: 'Ime',
        },
    },
    priimek: {
        name: 'priimek',
        type: 'xs:string',
        formType: 'text-input',
        required: true,
        value: '',
        text: {
            sl: 'Priimek',
        },
    },
    davcnaStevilka: {
        name: 'davcnaStevilka',
        type: 'xs:integer',
        formType: 'davcna-input',
        required: true,
        value: '',
        text: {
            sl: 'Davčna številka',
        },
    },
    datumRojstva: {
        name: 'datumRojstva',
        type: 'xs:date',
        formType: 'date-input',
        required: true,
        value: undefined,
        text: {
            sl: 'Datum rojstva',
        },
        conf: { deltaZavarovalniskaStarostMin: 15, deltaZavarovalniskaStarostMax: 68 },
    },
    krajRojstva: {
        name: 'krajRojstva',
        type: 'xs:string',
        formType: 'text-input',
        required: true,
        value: '',
        text: {
            sl: 'Kraj rojstva',
        },
    },
    drzavaRojstva: {
        name: 'drzavaRojstva',
        type: 'xs:string',
        formType: 'text-input',
        required: true,
        value: 'SLOVENIJA',
        text: {
            sl: 'Država rojstva',
        },
    },
    telefon: {
        name: 'telefon',
        type: 'xs:string',
        formType: 'phone-input',
        required: false,
        value: '',
        text: {
            sl: 'Telefonska številka',
        },
    },
    email: {
        name: 'email',
        type: 'xs:string',
        formType: 'email-input',
        required: false,
        value: '',
        text: {
            sl: 'Elektronska pošta',
        },
    },
    spol: {
        name: 'spol',
        type: 'tns:Spol',
        formType: 'gender-input',
        required: true,
        value: '',
        text: {
            sl: 'Spol',
        },
    },
    stevilkaZdravstveneKartice: {
        name: 'stevilkaZdravstveneKartice',
        type: 'xs:unsignedLong',
        formType: 'stevilka-zdravstvene-kartice-input',
        required: true,
        value: undefined,
        text: {
            sl: 'Številka zdravstvene kartice',
        },
    },
}

module.exports = { prvaDiagnozaZavarovanec };